import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {

  static targets = [
    'hiddenOffset',
    'hiddenDestroy',
    'datePickerInput',
    'numberInput',
    'hourInput',
    'minuteInput',
  ];

  static values = {
    startDate: String,
    url: String,
    method: String,
    envelope: String
  }

  connect() {
    if (this.hasNumberInputTarget) {
      this.numberInputTarget.addEventListener('blur', this._syncCalendar.bind(this));
    }

    if (this.hasDatePickerInputTarget) {
      this.datePickerInputTarget.addEventListener('change', this._syncNumber.bind(this));
    }
  }

  clearDates(event) {
    event.preventDefault();

    this._dispatchNumberChange('');
    this._dispatchDatePickerChange('');

    this._destroy(false);
  }

  clearTimeInputs(event) {
    event.preventDefault();

    if (this.hasHourInputTarget) {
      this.hourInputTarget.value = '';
      this.hourInputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (this.hasMinuteInputTarget) {
      this.minuteInputTarget.value = '';
      this.minuteInputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  clearDateAndTime(event) {
    event.preventDefault();

    // Clear date picker
    this._dispatchDatePickerChange('');

    // Clear time inputs
    if (this.hasHourInputTarget) {
      this.hourInputTarget.value = '';
      this.hourInputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (this.hasMinuteInputTarget) {
      this.minuteInputTarget.value = '';
      this.minuteInputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  _syncCalendar(event) {
    let newOffset = event.target.value;

    if (newOffset === '' || newOffset === undefined) {
      this._dispatchDatePickerChange('');
      this._destroy(false);
      this._postChanges(null, true);

      return;
    }

    if (this.startDateValue !== '') {
      const newDueDate = this._calculateNewDueDate(newOffset);
      this._dispatchDatePickerChange(this._formatCalendarInputDate(newDueDate));
    } else {
      this._dispatchDatePickerChange('');
    }

    this._destroy(true);
    this._setHiddenOffsetValue(newOffset);
    this._postChanges(newOffset);
  }

  _syncNumber() {
    if (this.datePickerInputTarget.value === '') {
      this._dispatchNumberChange('');
      this._dispatchDatePickerChange('');
      this._destroy(false);
      this._postChanges(null, true);

      return;
    }

    const newOffset = this._calculateOffset();
    this._dispatchNumberChange(newOffset);
    this._dispatchDatePickerChange(this.datePickerInputTarget.value);

    this._destroy(true);
    this._setHiddenOffsetValue(newOffset);
    this._postChanges(newOffset);
  }

  _calculateNewDueDate(offset) {
    let programStartDate = new Date(this.startDateValue);
    programStartDate.setUTCDate(programStartDate.getUTCDate() + parseInt(offset));

    return programStartDate;
  }

  _calculateOffset() {
    let programStartDate = new Date(this.startDateValue);

    let newDueDate = new Date(this.datePickerInputTarget.value);
    let oneDay = 1000 * 3600 * 24;
    let diffTime = newDueDate.getTime() - programStartDate.getTime();
    let diffDays = diffTime / oneDay;

    return diffDays;
  }

  _formatCalendarInputDate(date) {
    // return format "2021-07-30"
    return date.toISOString(true).slice(0,10);
  }

  _dispatchDatePickerChange(value) {
    const target = this.hasDatePickerInputTarget ? this.datePickerInputTarget : this.element;
    target.dispatchEvent(new CustomEvent('promote:datepicker-change', {
      detail: { value: value },
      bubbles: true
    }));
  }

  _dispatchNumberChange(value) {
    if (this.hasNumberInputTarget) {
      this.numberInputTarget.dispatchEvent(new CustomEvent('change', {
        detail: { value: value }
      }));
    }
  }

  _setHiddenOffsetValue(value) {
    if (this.hasHiddenOffsetTarget) {
      this.hiddenOffsetTarget.value = value + ' days';
    }
  }

  _destroy(shouldDestroy) {
    if (this.hasHiddenDestroyTarget) {
      this.hiddenDestroyTarget.disabled = shouldDestroy;
    }
  }

  _postChanges(offset, destroy = false) {
    if (this.urlValue === '' || this.methodValue === '' || this.envelopeValue === '') {
      return;
    }

    const body = new FormData();
    body.append(`${this.envelopeValue}[offset]`, `${offset} days`);
    body.append(`${this.envelopeValue}[anchor]`, 'start_at');

    if (destroy) {
      body.append(`${this.envelopeValue}[_destroy]`, true);
    }

    Rails.ajax({
      url: this.urlValue,
      type: this.methodValue,
      data: body,
      headers: {
        'Content-Type': 'application/json'
      },
      dataType: "script",
      success: (res) => {}
    });
  }
}
